export const STORE_LAYOUT_THRESHOLD = 12;

export type StoreLayout = 'few' | 'many';

export const pickStoreLayout = (storeCount: number): StoreLayout =>
  storeCount >= STORE_LAYOUT_THRESHOLD ? 'many' : 'few';
